import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { memoize } from '@angular/cli/src/utilities/memoize';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AdminChurchService } from 'src/app/_core/api/admin-church.service';
import { ModalActions, ModalEmitActions, Modals } from 'src/app/_core/constants/Modals';
import { ToastrMessages } from 'src/app/_core/constants/ToastrMessages';
import DateUtils from 'src/app/_core/helpers/DateUtils';
import Utils from 'src/app/_core/helpers/Utils';
import { AdminChurchDetails, History } from 'src/app/_core/models/AdminChurches';
import { AdminGroupResume } from 'src/app/_core/models/AdminFacilitators';
import { ResponseObject } from 'src/app/_core/models/GenericObject';
import { ModalRequest, ModalResponse } from 'src/app/_core/models/ModalEvent';
import { ModalsService } from 'src/app/_core/services/modals.service';
import { UserService } from 'src/app/_core/services/user.service';

@Component({
  selector: 'app-view-church',
  templateUrl: './view-church.component.html',
  styleUrls: ['./view-church.component.scss'],
})
export class ViewChurchComponent implements OnInit, OnDestroy {
  modalRequest: ModalRequest;
  churchDetails: AdminChurchDetails;
  modals = Modals;
  modalActions = ModalActions;
  breakpointSubscription: Subscription;
  isMobile: boolean;
  loading: boolean;
  isSuperAdmin = false;

  // prettier-ignore
  constructor(
    private toastr: ToastrService,
    private modalService: ModalsService,
    private adminChurchService: AdminChurchService,
    private dialogRef: MatDialogRef<ViewChurchComponent>,
    private breakpointObserver: BreakpointObserver,
    private currentUser: UserService,
  ) {
    this.isSuperAdmin = this.currentUser.isSuperAdmin();
    this.breakpointSubscription = this.breakpointObserver.observe('(max-width: 767px)').subscribe((result: BreakpointState) => {
      if (result.matches) {
        this.dialogRef.updateSize('100vw', '100vh');
        this.isMobile = true;
      } else {
        this.dialogRef.updateSize('75vw', '100vh');
      }
    });
  }

  ngOnInit(): void {
    this.modalRequest = this.modalService?.params;
    this.getChurchDetails();
  }

  ngOnDestroy(): void {
    this.breakpointSubscription.unsubscribe();
  }

  getChurchDetails(): void {
    this.loading = true;
    this.adminChurchService.getChurch(this.modalRequest.uuid).subscribe({
      next: (res: ResponseObject<AdminChurchDetails>) => {
        this.churchDetails = res.response;
        this.churchDetails.groups?.forEach((item: AdminGroupResume) => DateUtils.setLocalTime(item));
        this.churchDetails.historyList?.forEach((item: History) => (item.date = DateUtils.UTCtoLocalNoOffset(parseInt(item.date))));
        this.loading = false;
      },
      error: () => {
        this.toastr.error(...ToastrMessages.BASIC_ERROR);
        this.loading = false;
      },
    });
  }

  confirmChurch(): void {
    this.loading = true;
    this.adminChurchService.approveChurch(this.modalRequest.uuid).subscribe({
      next: () => {
        this.churchDetails.verified = true;
        this.toastr.success(...ToastrMessages.CHURCH_APPROVED);
        this.emit(ModalEmitActions.CHURCH_VERIFIED);
        this.loading = false;
      },
      error: () => {
        this.toastr.error(...ToastrMessages.CHURCH_APPROVAL_FAILED);
        this.loading = false;
      },
    });
  }

  emit(modalEmitAction: ModalEmitActions): void {
    const response = new ModalResponse(true, this.modalRequest, modalEmitAction);
    this.modalService.emitResponse(response);
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  @memoize
  get addressString(): string {
    return [this.churchDetails?.mainland?.region, this.churchDetails?.mainland?.subRegion, this.churchDetails?.mainland?.state]
      .filter((el) => {
        return el != null;
      })
      .join(', ');
  }

  externalNavigate(value: string): void {
    Utils.navigate(value);
  }

  openModal(modalName: Modals, modalAction: ModalActions, payload: any = null): void {
    this.modalService.openModal(modalName, { ...this.modalRequest, scope: modalAction, payload });
  }
}
